import prisma from '~/lib/prisma';

export default defineNuxtRouteMiddleware(async (to, from) => {
    try {


        if (import.meta.server) {
            // Lấy danh sách cookie hiện tại
            const cookies = useCookie('auth.public-token', {
                maxAge: 60 * 60 * 24 * 7, // 7 ngày
            });

            // Kiểm tra nếu cookie đã tồn tại
            if (cookies.value) {
                console.log('Token already exists in cookie');
                return;
            }

            // Truy vấn từ Prisma để lấy token
            const token = await prisma.publicToken.findFirst({
                where: {
                    is_active: true,
                    expires_at: {
                        gte: new Date(),
                    },
                },
                select: {
                    token: true,
                },
            });

            if (token) {
                // Sử dụng hàm setCookie để thiết lập
                cookies.value = token.token;
                console.log('Cookie đã được set');
                useNuxtApp().provide('publicToken', token.token);
            }
        }
    } catch (error) {
        console.log(`Lỗi khi thiết lập cookie: ${error}`);

    }
});
